import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AppraisalTaskCommunicationStore } from '../stores/appraisalTaskCommunicationStore';

export const useAppraisalTaskCommunicationStore = () => useContext<{
  appraisalTaskCommunicationStore: AppraisalTaskCommunicationStore
}>(StoreContext);
